import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/icons/default.module.scss';

const propTypes = {
    color: PropTypes.string,
    circleColor: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#222',
    circleColor: '#00e164',
    className: null,
};

const PlusIcon = ({ color, circleColor, className }) => (
    <svg id="b" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.89 40.89" className={className}>
        <g id="c">
            <g>
                <circle cx="20.44" cy="20.44" r="20.44" fill={circleColor} />
                <line
                    x1="20.44"
                    y1="5.73"
                    x2="20.44"
                    y2="35.16"
                    fill="none"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeWidth="4"
                />
                <line
                    x1="35.16"
                    y1="20.44"
                    x2="5.73"
                    y2="20.44"
                    fill="none"
                    stroke={color}
                    strokeMiterlimit="10"
                    strokeWidth="4"
                />
            </g>
        </g>
    </svg>
);

PlusIcon.propTypes = propTypes;
PlusIcon.defaultProps = defaultProps;

export default PlusIcon;
